
// import React from "react";
// import "./Home.css";
// import Product from "./Product"
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from "react-responsive-carousel";


// function Home() {
//   return (
//     <div className="home">
//       <div className="home__container">

   
//       <Carousel className= "home__image"
//       autoPlay
//       infiniteLoop
//       showStatus={false}
//       showIndicators={false}
//       showThumbs={false}
//       interval={2000}>
        
//                 <div >
//                     <img src="https://images-na.ssl-images-amazon.com/images/G/01/kindle/journeys/ZmVhMDM4ZmYt/ZmVhMDM4ZmYt-MzAwYjhkNmUt-w3000._CB662250011_.jpg" />
                  
//                 </div>
//                 <div>
//                     <img src="https://images-na.ssl-images-amazon.com/images/G/01/kindle/journeys/NDdhM2JmYjct/NDdhM2JmYjct-MzBhMTUwY2Yt-w3000._CB668833935_.jpg
// " />
                   
//                 </div>
//                 <div>
//                     <img src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonMusic/2021/Marketing/EvergreenFree_DMUX-4110/Gateway/DV3A/US-EN_030121_FreeTierQ1Refresh_ACQ_GW_Hero_D_3000x1200_CV3._CB655482702_.jpg" />
//                 </div>
//                 <div>
//                     <img src="https://images-na.ssl-images-amazon.com/images/G/01/Audible/Revelation-GatewayHeroDesktop-English-2x-3000x1200-V03._CB655334651_.jpg" alt="" />
//                 </div>
//             </Carousel>

//           {/* <img
//           className="home__image"
//           src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
//           alt="" 
//         />  */}
//         {/* <img  className="home__image"  alt="Alexa, arm the house to away. Ring Alarm. 5 piece kit. $159.99 Limited time offer." src="https://images-na.ssl-images-amazon.com/images/G/01/kindle/journeys/MTA2NmNiMzMt/MTA2NmNiMzMt-N2FjYmMyNjUt-w3000._CB669465000_.jpg" height="600px" width="1500px" data-a-hires="https://images-na.ssl-images-amazon.com/images/G/01/kindle/journeys/MTA2NmNiMzMt/MTA2NmNiMzMt-N2FjYmMyNjUt-w3000._CB669465000_.jpg"/> */}
//         <div className="home__row">
//           <Product
//             id="12321341"
//             title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
//             price={11.96}
//             rating={5}
//             image="https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._SX325_BO1,204,203,200_.jpg"
//           />
//           <Product
//             id="49538094"
//             title="Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl"
//             price={239.0}
//             rating={4}
//             image="https://images-na.ssl-images-amazon.com/images/I/81O%2BGNdkzKL._AC_SX450_.jpg"
//           />
//         </div>

//         <div className="home__row">

//           <Product
//             id="4903850"
//             title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
//             price={199.99}
//             rating={3}
//             image="https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg"
//           />
//           <Product
//             id="23445930"
//             title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
//             price={98.99}
//             rating={5}
//             image="https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$"
//           />
//           <Product
//             id="3254354345"
//             title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
//             price={598.99}
//             rating={4}
//             image="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
//           />
//         </div>
//         <div className="home__row">

// <Product
//   id="4903850"
//   title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
//   price={199.99}
//   rating={3}
//   image="https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg"
// />
// <Product
//   id="23445930"
//   title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
//   price={98.99}
//   rating={5}
//   image="https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$"
// />
// <Product
//   id="3254354345"
//   title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
//   price={598.99}
//   rating={4}
//   image="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
// />
// </div>

//         <div className="home__row">
//           <Product
//             id="90829332"
//             title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440"
//             price={1094.98}
//             rating={4}
//             image="https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg"
//           />
//         </div>

//       </div>

//     </div>
//     );
// };

// export default Home;
import React from "react";
import "./Home.css";
import Product from "./Product"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
      <Carousel className= "home__image"
      autoPlay
      infiniteLoop
      showStatus={false}
      showIndicators={false}
      showThumbs={false}
      interval={2000}
      
      
      >
        
                <div >
                    <img src="https://images-na.ssl-images-amazon.com/images/G/01/kindle/journeys/ZmVhMDM4ZmYt/ZmVhMDM4ZmYt-MzAwYjhkNmUt-w3000._CB662250011_.jpg" />
                  
                </div>
                <div>
                    <img src="https://images-na.ssl-images-amazon.com/images/G/01/AMAZON_FASHION/2021/journeys/MzBiNjIyYjgt/MzBiNjIyYjgt-MTVlZTk4NTYt-w3000._CB669954919_.jpg" />
                   
                </div>
                <div>
                    <img src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonMusic/2021/Marketing/EvergreenFree_DMUX-4110/Gateway/DV3A/US-EN_030121_FreeTierQ1Refresh_ACQ_GW_Hero_D_3000x1200_CV3._CB655482702_.jpg" />
                </div>
            </Carousel>
          {/* <img
          className="home__image"
          src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
          alt="" 
        />  */}
        {/* <img  className="home__image"  alt="Alexa, arm the house to away. Ring Alarm. 5 piece kit. $159.99 Limited time offer." src="https://images-na.ssl-images-amazon.com/images/G/01/kindle/journeys/MTA2NmNiMzMt/MTA2NmNiMzMt-N2FjYmMyNjUt-w3000._CB669465000_.jpg" height="600px" width="1500px" data-a-hires="https://images-na.ssl-images-amazon.com/images/G/01/kindle/journeys/MTA2NmNiMzMt/MTA2NmNiMzMt-N2FjYmMyNjUt-w3000._CB669465000_.jpg"/> */}
        <div className="home__row">
          <Product
            id="12321341"
            // title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            title="Wyze Cam v3 1080p HD
            Indoor/Outdoor Video Camera for
            Security, Pets, Baby Monitor, w/Color
            Night Vision, 2-Way Audio, Works with
            Alexa & Google"
            price={32.98}
            rating={5}
            // image="https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._SX325_BO1,204,203,200_.jpg"
            image="https://images-na.ssl-images-amazon.com/images/I/61DJRLNgyWL._AC_SL1500_.jpg"
          />
          <Product
            id="49538094"
            title="New Apple AirTag"
            price={29}
            rating={4}
            image="https://images-na.ssl-images-amazon.com/images/I/713xuNx00oS._AC_SL1500_.jpg"
          />
        </div>

        <div className="home__row">

          <Product
            id="4903850"
            title="New Apple Watch Series 6 (GPS, 44mm) - (Product) RED - Aluminum Case with (Product) RED﻿ - Sport Band"
            price={429.99}
            rating={5}
            image="https://images-na.ssl-images-amazon.com/images/I/81LS-PwwQPL._AC_SL1500_.jpg"
          />
          <Product
            id="23445930"
            title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
            price={249.99}
            rating={5}
            image="https://images-na.ssl-images-amazon.com/images/I/51DT5-NEvDS._AC_SL1000_.jpg"
          />
          <Product
            id="3254354345"
            title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
            price={598.99}
            rating={4}
            image="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
          />
        </div>
        <div className="home__row">

<Product
  id="4903850"
  title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
  price={199.99}
  rating={3}
  image="https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg"
/>
<Product
  id="23445930"
  title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
  price={98.99}
  rating={5}
  image="https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$"
/>
<Product
  id="3254354345"
  title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
  price={598.99}
  rating={4}
  image="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
/>
</div>

        <div className="home__row">
          <Product
            id="90829332"
            title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440"
            price={1094.98}
            rating={4}
            image="https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg"
          />
        </div>

      </div>

    </div>
    );
};

export default Home;